import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_app",
  ref: "createAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_8 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_9 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_10 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = { class: "fv-row" }
const _hoisted_14 = { class: "fv-row" }
const _hoisted_15 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_16 = { class: "d-flex align-items-center me-2" }
const _hoisted_17 = { class: "symbol symbol-50px me-6" }
const _hoisted_18 = { class: "symbol-label bg-light-primary" }
const _hoisted_19 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_21 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_22 = { class: "d-flex align-items-center me-2" }
const _hoisted_23 = { class: "symbol symbol-50px me-6" }
const _hoisted_24 = { class: "symbol-label bg-light-danger" }
const _hoisted_25 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_26 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_27 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_28 = { class: "d-flex align-items-center me-2" }
const _hoisted_29 = { class: "symbol symbol-50px me-6" }
const _hoisted_30 = { class: "symbol-label bg-light-success" }
const _hoisted_31 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_33 = { "data-kt-stepper-element": "content" }
const _hoisted_34 = { class: "w-100" }
const _hoisted_35 = { class: "fv-row" }
const _hoisted_36 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_37 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_38 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_39 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_40 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_41 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_42 = { "data-kt-stepper-element": "content" }
const _hoisted_43 = { class: "w-100" }
const _hoisted_44 = { class: "fv-row mb-10" }
const _hoisted_45 = { class: "fv-row" }
const _hoisted_46 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_47 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_48 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_49 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_50 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_51 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_52 = { "data-kt-stepper-element": "content" }
const _hoisted_53 = { class: "w-100" }
const _hoisted_54 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_55 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_56 = { class: "position-relative" }
const _hoisted_57 = { class: "row mb-10" }
const _hoisted_58 = { class: "col-md-8 fv-row" }
const _hoisted_59 = { class: "row fv-row" }
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = ["label", "value"]
const _hoisted_62 = { class: "col-6" }
const _hoisted_63 = ["label", "value"]
const _hoisted_64 = { class: "col-md-4 fv-row" }
const _hoisted_65 = { class: "position-relative" }
const _hoisted_66 = { class: "position-absolute translate-middle-y top-50 end-0 me-3" }
const _hoisted_67 = { class: "svg-icon svg-icon-2hx" }
const _hoisted_68 = { class: "d-flex flex-stack" }
const _hoisted_69 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_70 = { class: "d-flex flex-stack pt-10" }
const _hoisted_71 = { class: "me-2" }
const _hoisted_72 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_73 = { class: "indicator-label" }
const _hoisted_74 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_75 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_76 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Create App", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, {
                src: "/media/icons/duotune/arrows/arr061.svg",
                "aria-hidden": "true"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\" data-v-5b56d0e4><div class=\"stepper-nav ps-lg-10\" data-v-5b56d0e4><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-5b56d0e4><div class=\"stepper-line w-40px\" data-v-5b56d0e4></div><div class=\"stepper-icon w-40px h-40px\" data-v-5b56d0e4><i class=\"stepper-check fas fa-check\" data-v-5b56d0e4></i><span class=\"stepper-number\" data-v-5b56d0e4>1</span></div><div class=\"stepper-label\" data-v-5b56d0e4><h3 class=\"stepper-title\" data-v-5b56d0e4>Details</h3><div class=\"stepper-desc\" data-v-5b56d0e4>Name your App</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-5b56d0e4><div class=\"stepper-line w-40px\" data-v-5b56d0e4></div><div class=\"stepper-icon w-40px h-40px\" data-v-5b56d0e4><i class=\"stepper-check fas fa-check\" data-v-5b56d0e4></i><span class=\"stepper-number\" data-v-5b56d0e4>2</span></div><div class=\"stepper-label\" data-v-5b56d0e4><h3 class=\"stepper-title\" data-v-5b56d0e4>Frameworks</h3><div class=\"stepper-desc\" data-v-5b56d0e4>Define your app framework</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-5b56d0e4><div class=\"stepper-line w-40px\" data-v-5b56d0e4></div><div class=\"stepper-icon w-40px h-40px\" data-v-5b56d0e4><i class=\"stepper-check fas fa-check\" data-v-5b56d0e4></i><span class=\"stepper-number\" data-v-5b56d0e4>3</span></div><div class=\"stepper-label\" data-v-5b56d0e4><h3 class=\"stepper-title\" data-v-5b56d0e4>Database</h3><div class=\"stepper-desc\" data-v-5b56d0e4>Select the app database type</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-5b56d0e4><div class=\"stepper-line w-40px\" data-v-5b56d0e4></div><div class=\"stepper-icon w-40px h-40px\" data-v-5b56d0e4><i class=\"stepper-check fas fa-check\" data-v-5b56d0e4></i><span class=\"stepper-number\" data-v-5b56d0e4>4</span></div><div class=\"stepper-label\" data-v-5b56d0e4><h3 class=\"stepper-title\" data-v-5b56d0e4>Billing</h3><div class=\"stepper-desc\" data-v-5b56d0e4>Provide payment details</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-5b56d0e4><div class=\"stepper-line w-40px\" data-v-5b56d0e4></div><div class=\"stepper-icon w-40px h-40px\" data-v-5b56d0e4><i class=\"stepper-check fas fa-check\" data-v-5b56d0e4></i><span class=\"stepper-number\" data-v-5b56d0e4>5</span></div><div class=\"stepper-label\" data-v-5b56d0e4><h3 class=\"stepper-title\" data-v-5b56d0e4>Release</h3><div class=\"stepper-desc\" data-v-5b56d0e4>Review and Submit</div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", {
                class: "form",
                novalidate: "novalidate",
                id: "kt_modal_create_app_form",
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
                        _createElementVNode("span", { class: "required" }, "App Name"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Specify your unique app name"
                        })
                      ], -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg",
                        name: "appName",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "appName"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
                        _createElementVNode("span", { class: "required" }, "Category"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Select your app category"
                        })
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/maps/map004.svg" })
                                ])
                              ])
                            ]),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "d-flex flex-column" }, [
                              _createElementVNode("span", { class: "fw-bolder fs-6" }, "Quick Online Courses"),
                              _createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one SEO")
                            ], -1))
                          ]),
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "1"
                            })
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen024.svg" })
                                ])
                              ])
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "d-flex flex-column" }, [
                              _createElementVNode("span", { class: "fw-bolder fs-6" }, "Face to Face Discussions"),
                              _createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one aspect")
                            ], -1))
                          ]),
                          _createElementVNode("span", _hoisted_26, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "2"
                            })
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, [
                                _createElementVNode("span", _hoisted_31, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen013.svg" })
                                ])
                              ])
                            ]),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "d-flex flex-column" }, [
                              _createElementVNode("span", { class: "fw-bolder fs-6" }, "Full Intro Training"),
                              _createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure copywriting")
                            ], -1))
                          ]),
                          _createElementVNode("span", _hoisted_32, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "3"
                            })
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "category"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
                        _createElementVNode("span", { class: "required" }, "Select Framework"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Specify your apps framework"
                        })
                      ], -1)),
                      _createElementVNode("label", _hoisted_36, [
                        _cache[9] || (_cache[9] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-warning\" data-v-5b56d0e4><i class=\"fab fa-html5 text-warning fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>HTML5</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Base Web Projec</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_37, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "framework",
                            value: "1"
                          })
                        ])
                      ]),
                      _cache[13] || (_cache[13] = _createStaticVNode("<label class=\"d-flex flex-stack cursor-pointer mb-5\" data-v-5b56d0e4><span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-success\" data-v-5b56d0e4><i class=\"fab fa-react text-success fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>ReactJS</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Robust and flexible app framework</span></span></span><span class=\"form-check form-check-custom form-check-solid\" data-v-5b56d0e4><input class=\"form-check-input\" type=\"radio\" name=\"framework\" value=\"2\" data-v-5b56d0e4></span></label>", 1)),
                      _createElementVNode("label", _hoisted_38, [
                        _cache[10] || (_cache[10] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-danger\" data-v-5b56d0e4><i class=\"fab fa-angular text-danger fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>Angular</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Powerful data mangement</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_39, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "framework",
                            value: "3"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_40, [
                        _cache[11] || (_cache[11] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-primary\" data-v-5b56d0e4><i class=\"fab fa-vuejs text-primary fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>Vue</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Lightweight and responsive framework</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_41, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "framework",
                            value: "4"
                          })
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "framework"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, " Database Name ", -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg",
                        name: "dbName",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "dbName"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
                        _createElementVNode("span", { class: "required" }, "Select Database Engine"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Select your app database engine"
                        })
                      ], -1)),
                      _createElementVNode("label", _hoisted_46, [
                        _cache[15] || (_cache[15] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-success\" data-v-5b56d0e4><i class=\"fas fa-database text-success fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>MySQL</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Basic MySQL database</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_47, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "1"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_48, [
                        _cache[16] || (_cache[16] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-danger\" data-v-5b56d0e4><i class=\"fab fa-google text-danger fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>Firebase</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Google based app data management</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_49, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "2"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_50, [
                        _cache[17] || (_cache[17] = _createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-5b56d0e4><span class=\"symbol symbol-50px me-6\" data-v-5b56d0e4><span class=\"symbol-label bg-light-warning\" data-v-5b56d0e4><i class=\"fab fa-amazon text-warning fs-2x\" data-v-5b56d0e4></i></span></span><span class=\"d-flex flex-column\" data-v-5b56d0e4><span class=\"fw-bolder fs-6\" data-v-5b56d0e4>DynamoDB</span><span class=\"fs-7 text-muted\" data-v-5b56d0e4>Amazon Fast NoSQL Database</span></span></span>", 1)),
                        _createElementVNode("span", _hoisted_51, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "3"
                          })
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "dbType"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                        _createElementVNode("span", { class: "required" }, "Name On Card"),
                        _createElementVNode("i", {
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          title: "Specify a card holder's name"
                        })
                      ], -1)),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control",
                        placeholder: "",
                        name: "nameOnCard"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "nameOnCard"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Card Number", -1)),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control",
                          placeholder: "Enter card number",
                          name: "cardNumber"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "cardNumber"
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "position-absolute translate-middle-y top-50 end-0 me-5" }, [
                          _createElementVNode("img", {
                            src: "/media/svg/card-logos/visa.svg",
                            alt: "",
                            class: "h-25px"
                          }),
                          _createElementVNode("img", {
                            src: "/media/svg/card-logos/mastercard.svg",
                            alt: "",
                            class: "h-25px"
                          }),
                          _createElementVNode("img", {
                            src: "/media/svg/card-logos/american-express.svg",
                            alt: "",
                            class: "h-25px"
                          })
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Expiration Date", -1)),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_Field, {
                              name: "cardExpiryMonth",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Month",
                              as: "select"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                  return _createElementVNode("option", {
                                    key: i,
                                    label: i,
                                    value: i
                                  }, null, 8, _hoisted_61)
                                }), 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "cardExpiryMonth"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_Field, {
                              name: "cardExpiryYear",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Year",
                              as: "select"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                                  return _createElementVNode("option", {
                                    key: i,
                                    label: i + (new Date().getFullYear() - 1),
                                    value: i
                                  }, null, 8, _hoisted_63)
                                }), 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "cardExpiryYear"
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
                          _createElementVNode("span", { class: "required" }, "CVV"),
                          _createElementVNode("i", {
                            class: "fas fa-exclamation-circle ms-2 fs-7",
                            "data-bs-toggle": "tooltip",
                            title: "Enter a card CVV code"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control",
                            minlength: "3",
                            maxlength: "4",
                            placeholder: "CVV",
                            name: "cardCvv"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "cardCvv"
                          }),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("span", _hoisted_67, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin002.svg" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "me-5" }, [
                        _createElementVNode("label", { class: "fs-6 fw-bold form-label" }, "Save Card for further billing?"),
                        _createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please check budget planning ")
                      ], -1)),
                      _createElementVNode("label", _hoisted_69, [
                        _createVNode(_component_Field, {
                          type: "checkbox",
                          class: "form-check-input",
                          name: "saveCard",
                          value: "1"
                        }),
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " Save Card ", -1))
                      ])
                    ])
                  ])
                ]),
                _cache[30] || (_cache[30] = _createStaticVNode("<div data-kt-stepper-element=\"content\" data-v-5b56d0e4><div class=\"w-100 text-center\" data-v-5b56d0e4><h1 class=\"fw-bolder text-dark mb-3\" data-v-5b56d0e4>Release!</h1><div class=\"text-muted fw-bold fs-3\" data-v-5b56d0e4> Submit your app to kickstart your project. </div><div class=\"text-center px-4 py-15\" data-v-5b56d0e4><img src=\"/media/illustrations/sketchy-1/9.png\" alt=\"\" class=\"w-100 mh-300px\" data-v-5b56d0e4></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-dark-blue me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousStep()))
                    }, [
                      _createElementVNode("span", _hoisted_72, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _cache[26] || (_cache[26] = _createTextVNode(" Back ", -1))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          class: "btn btn-lg btn-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                        }, [
                          _createElementVNode("span", _hoisted_73, [
                            _cache[27] || (_cache[27] = _createTextVNode(" Submit ", -1)),
                            _createElementVNode("span", _hoisted_74, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                            ])
                          ]),
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "indicator-progress" }, [
                            _createTextVNode(" Please wait... "),
                            _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                          ], -1))
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_75, [
                          _cache[29] || (_cache[29] = _createTextVNode(" Continue ", -1)),
                          _createElementVNode("span", _hoisted_76, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                  ])
                ])
              ], 32)
            ])
          ], 512)
        ])
      ])
    ])
  ], 512))
}